import React, { useState } from "react";
import Modaal from "./modaal";
import { IoIosArrowForward } from "react-icons/io";
import { Buttton } from "../../components";
import { useLocation } from "react-router-dom";

const CookiesPolicyModal = () => {
    const location = useLocation();
    const [showModal, setShowModal] = useState(true);
    if (
        location.pathname === "/patient/login" ||
        location.pathname === "/patient/register" ||
        location.pathname === "/patient/forgot-password" ||
        location.pathname === "/patient/verify-otp" ||

        location.pathname === "/doctor/login" ||
        location.pathname === "/doctor/register" ||
        location.pathname === "/doctor/forgot-password" ||
        location.pathname === "/doctor/verify-otp" ||
        location.pathname === "/doctor/contact" ||


        location.pathname === "/admin/login" ||
        location.pathname === "/admin/forgot-password" ||
        location.pathname === "/admin/verify-otp"
    ) {
        return null;
    }
    const handleReject = () => {
        setShowModal(false); // Close the modal
    };

    return (
        <Modaal
            size="lg"
            show={showModal}
            onHide={handleReject}
            title={
                <div className="mTitleBlk">
                    <h2 className="mTitle">We use cookies to analyze the site usage</h2>
                </div>
            }
            footer={
                <>
                    <div className="modal-footer-blk">
                        <div className="modal-footer-social">
                            <div className="modal-footer-txt">
                                PERSONALIZE EXPIERENCE <IoIosArrowForward className="rarrow" />{" "}
                            </div>
                            <Buttton.Buttton
                                children="REJECT"
                                onClick={handleReject}
                                className="transparent"
                            />
                        </div>
                        <Buttton.Buttton
                            children="ACCEPT ALL"
                            className="btn-border-Aqua_Teal"
                        />
                    </div>
                </>
            }
            className="cookies-policy-modal"
        />
    );
};

export default CookiesPolicyModal;
